export interface Categoria {
    idCategoria: number,
    txNombreCategoria: string,
    bdInstitucional: boolean,
    bdEstadoRegistro: boolean,
    txtDescripcion: string,
}

export function GetVoidCategoria(): Categoria {
    return {
        idCategoria: 0,
        txNombreCategoria: '',
        bdInstitucional: false,
        bdEstadoRegistro: false,
        txtDescripcion: '',
    }
}